import { jsx } from 'react/jsx-runtime';
import { EGDSCalendarNavigationPagination } from '../calendar-navigation-pagination/index.esm.js';
import { EGDSCalendarNavigationScrolling } from '../calendar-navigation-scrolling/index.esm.js';
import '../../../styles/uitk-egds-calendar.css';
const EGDSCalendarNavigation = props => {
  const {
    navType,
    onScrollHandler,
    ...rest
  } = props;
  EGDSCalendarNavigation.displayName = 'EGDSCalendarNavigation';
  if (navType === 'scrolling') {
    return jsx(EGDSCalendarNavigationScrolling, {
      navType: "scrolling",
      onScrollHandler: onScrollHandler,
      ...rest
    });
  }
  return jsx(EGDSCalendarNavigationPagination, {
    ...rest,
    navType: navType
  });
};
export { EGDSCalendarNavigation };